module.exports = "/_next/static/images/823ad4ccca0c944a6441bfeab806f181-word-cup-lg-3x.png.webp";